/**
 * A − value + stepper with big targets (§15.1): easier than a number field on a phone held in
 * one hand. The value is clamped to [min, max]; the buttons disable at the ends.
 */
export function Stepper({
  value,
  min,
  max,
  step = 1,
  label,
  format = String,
  onChange,
  disabled = false,
  testId,
}: {
  value: number;
  min: number;
  max: number;
  step?: number;
  /** Accessible name of the value ("Leak limit"). */
  label: string;
  format?: (value: number) => string;
  onChange: (value: number) => void;
  disabled?: boolean;
  testId?: string;
}) {
  const clamp = (v: number) => Math.min(max, Math.max(min, v));
  const down = clamp(value - step);
  const up = clamp(value + step);
  return (
    <div className="stepper" data-testid={testId}>
      <button
        type="button"
        className="btn small"
        aria-label={`Decrease ${label}`}
        data-testid={testId ? `${testId}-down` : undefined}
        disabled={disabled || down === value}
        onClick={() => onChange(down)}
      >
        −
      </button>
      <output aria-label={label} data-testid={testId ? `${testId}-value` : undefined}>
        {format(value)}
      </output>
      <button
        type="button"
        className="btn small"
        aria-label={`Increase ${label}`}
        data-testid={testId ? `${testId}-up` : undefined}
        disabled={disabled || up === value}
        onClick={() => onChange(up)}
      >
        +
      </button>
    </div>
  );
}
